import {ExportContainer} from "../../Model/dataProcess/exportContainer";
import {Injectable} from "@angular/core";
import {GenericService} from "../generic/genericRepository.service";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ExportContainerService extends GenericService<ExportContainer> {

  constructor(http: HttpClient) {
    super(http);
    this.apiUrl = "api/ExportContainer";
  }
}
